import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Publishers = () => import('@/views/Publishers')
const Listings = () => import('@/views/Listings')
const ListingIndex = () => import('@/views/listings/Index')
const ListingSingle = () => import('@/views/listings/Single')
const ListingOverview = () => import('@/views/listings/Overview')
const ListingForm = () => import('@/views/listings/Form')
const Messages = () => import('@/views/Messages')
const MessagesIndex = () => import('@/views/messages/Index')
const Account = () => import('@/views/Account')
const Support = () => import('@/views/Support')

// Utility
const Login = () => import('@/views/Login')
const Forgot = () => import('@/views/login/forgot/Index')
const ForgotReset = () => import('@/views/login/forgot/Reset')

// Views - Pages
const Error404 = () => import('@/views/404')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            auth: true
          }
        },
        {
          path: 'publishers',
          name: 'Publishers',
          component: Publishers,
          meta: {
            auth: true
          }
        },
        {
          path: 'listings',
          name: 'Listings',
          redirect: '/listings',
          component: Listings,
          meta: {
            auth: true
          },
          children: [
            {
              path: '',
              component: ListingIndex
            },
            {
              path: 'new',
              name: 'NewListing',
              redirect: '/listings/new',
              component: ListingSingle,
              meta: {
                label: false
              },
              children: [
                {
                  path: '',
                  component: ListingForm,
                  meta: {
                    label: 'New Listing'
                  }
                },
              ]
            },
            {
              path: ':id',
              name: 'ListingSingle',
              redirect: '/listings/:id',
              component: ListingSingle,
              props: true,
              meta: {
                label: 'Overview',
              },
              children: [
                {
                  path: '',
                  name: 'ListingOverview',
                  component: ListingOverview,
                  meta: {
                    label: false
                  }
                },
                {
                  path: 'edit',
                  name: 'EditListing',
                  component: ListingForm,
                  props: true,
                  meta: {
                    label: 'Edit Listing'
                  }
                },
              ]
            },
          ]
        },
        {
          path: 'messages',
          name: 'Messages',
          component: Messages,
          redirect: '/messages',
          meta: {
            auth: true,
            label: 'My Messages'
          },
          children: [
            {
              path: '',
              component: MessagesIndex
            },
          ]
        },
        {
          path: 'account',
          name: 'Account',
          component: Account,
          meta: {
            auth: true,
            label: 'My Account'
          }
        },
        {
          path: 'support',
          name: 'Support',
          component: Support,
          meta: {
            auth: true
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot,
    },
    {
      path: '/forgot/reset',
      name: 'Reset',
      component: ForgotReset,
    },
    {
      path: '*',
      name: 'Error404',
      component: Error404
    }
  ]
})
